//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
var $t = Vue.prototype.$t;
// 规则
var rules = {
  name: [{
    required: true,
    message: $t('1149'),
    trigger: 'blur'
  }],
  type: [{
    required: true,
    message: $t('796'),
    trigger: 'blur'
  }]
};
var form = function form() {
  return {
    name: '',
    type: ''
  };
};
export default {
  props: {
    visible: {
      default: true
    },
    typeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    visible: function visible(v) {
      if (!v) this.form = form();
    }
  },
  data: function data() {
    return {
      form: form(),
      rules: rules
    };
  },
  methods: {
    close: function close() {
      this.$emit('update:visible', false);
    },
    // 隐藏当前弹窗
    handlerChangeVisible: function handlerChangeVisible() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.$emit('handlerCreate', _this.form);
        }
      });
    }
  }
};